import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { pxToRem } from '../../helpers/pxToRem';
import { capitalize } from '../../helpers/strings';
import { isHexColor } from '../../helpers/hexColors';
import { vitalStyles } from '../styles';
import * as styles from './Typography.module.scss';
const Heading = [styles.heading];
const Heading10 = [...Heading, styles.heading10];
const Heading20 = [...Heading, styles.heading20];
const Heading30 = [...Heading, styles.heading30];
const Heading40 = [...Heading, styles.heading40];
const Heading50 = [...Heading, styles.heading50];
const Heading60 = [...Heading, styles.heading60];
const Body = [styles.body];
const BodyXSmall = [...Body, styles.bodyXs];
const BodySmall = [...Body, styles.bodySm];
const BodyMedium = [...Body, styles.bodyMd];
const BodyLarge = [...Body, styles.bodyLg];
const BodyXLarge = [...Body, styles.bodyXl];
const Component = [styles.component];
const ComponentXSmall = [...Component, styles.componentXs];
const ComponentSmall = [...Component, styles.componentSm];
const ComponentMedium = [...Component, styles.componentMd];
const ComponentLarge = [...Component, styles.componentLg];
const ComponentXLarge = [...Component, styles.componentXl];
const Name = 'Typography';
const createTextComponent = (TextComponent, classNames) => ({ as: Component = TextComponent, className, children, fontColor, marginTop, marginBottom, marginLeft, centered = false, underline = false, textIndent, numberOfLines, testID, maxWidth, bold, }) => {
    const isHex = isHexColor(fontColor);
    return (_jsx(Component, { "data-testid": testID, "data-component": Name, style: {
            ...(typeof textIndent === 'number'
                ? { textIndent: pxToRem(textIndent) }
                : {}),
            ...(numberOfLines ? { WebkitLineClamp: numberOfLines } : {}),
            ...(isHex
                ? {
                    color: fontColor,
                }
                : {}),
            ...(marginTop != null ? { marginTop: pxToRem(marginTop) } : {}),
            ...(marginBottom != null
                ? { marginBottom: pxToRem(marginBottom) }
                : {}),
            ...(marginLeft != null ? { marginLeft: pxToRem(marginLeft) } : {}),
            ...(maxWidth != null ? { maxWidth } : {}),
            ...(bold ? { fontWeight: 'bold' } : {}),
        }, className: clsx(!isHex && fontColor && vitalStyles[`fg${capitalize(fontColor)}`], centered ? styles.textAlignCentered : styles.textAlignInitial, underline
            ? styles.textDecorationUnderline
            : styles.textDecorationNone, numberOfLines && styles.lineClamp, ...classNames, className), children: children }));
};
const HeadingText10Component = createTextComponent('h6', Heading10);
// Creates a text component which can be analyzed by react-docgen
export const HeadingText10 = ({ ...props }) => (_jsx(HeadingText10Component, { ...props }));
export const HeadingText20 = createTextComponent('h5', Heading20);
export const HeadingText30 = createTextComponent('h4', Heading30);
export const HeadingText40 = createTextComponent('h3', Heading40);
export const HeadingText50 = createTextComponent('h2', Heading50);
export const HeadingText60 = createTextComponent('h1', Heading60);
export const BodyTextXSmall = createTextComponent('p', BodyXSmall);
export const BodyTextSmall = createTextComponent('p', BodySmall);
export const BodyTextMedium = createTextComponent('p', BodyMedium);
export const BodyTextLarge = createTextComponent('p', BodyLarge);
export const BodyTextXLarge = createTextComponent('p', BodyXLarge);
export const ComponentTextXSmall = createTextComponent('span', ComponentXSmall);
export const ComponentTextSmall = createTextComponent('span', ComponentSmall);
export const ComponentTextMedium = createTextComponent('span', ComponentMedium);
export const ComponentTextLarge = createTextComponent('span', ComponentLarge);
export const ComponentTextXLarge = createTextComponent('span', ComponentXLarge);
